import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Ícono estándar para el acordeón
import {OperacionContraparteLimitesSectorComercialFields} from "../../sistema/sistemas/contraparte/types/fields";
import {OperacionContraparteLimitesAprobadosSectorComercial} from "../../sistema/sistemas/contraparte/types/dto";
import LimitesContraparteTabla from "./LimitesContraparteTabla";

interface LimiteContraparteSectorComercialProps {
    data: OperacionContraparteLimitesAprobadosSectorComercial;
    loading?: boolean;
    error?: boolean;
}

function LimiteContraparteSectorComercial({data, loading, error}: LimiteContraparteSectorComercialProps) {
    const sectorCodigo = data[OperacionContraparteLimitesSectorComercialFields.CodSectorComercial];

    return (
        <Accordion defaultExpanded>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                id={`panel-${sectorCodigo}-header`}
            >
                <Typography variant="h6" component="h3">
                    {data[OperacionContraparteLimitesSectorComercialFields.NombreSectorComercial]}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{px: 0, pb: 0}}>
                <LimitesContraparteTabla
                    limites={data[OperacionContraparteLimitesSectorComercialFields.ListaLimites]}
                    loading={loading}
                    error={error}
                />
            </AccordionDetails>
        </Accordion>
    );
}

export default LimiteContraparteSectorComercial;
